<template lang="pug">
  .address-layout
    .header.white
      v-container.pa-0(style="max-width:600px")
        head-bar
    .zone-layout(v-if="page === 1")
      v-container(style="max-width:600px")
        .select-zone
          div.title.text-center.font-weight-bold Select your delivery location
          div.caption.text-center.mb-4 Do please consult with
            a.mx-1(@click="clickAskMerchat()") {{ leadData.form.company.name }} 
            | if you have problem choosing this option.
            div.red--text.mt-4.body-2(v-if="errorMessage") {{ errorMessage }}
          v-form(ref="addressForm")
            v-card(outlined)
              v-list.pa-0
                v-list-item-group(v-model='selectedZone', color='primary')
                  template(v-for='(zone, index) in zones')
                    v-divider(v-if="index != 0")
                    v-list-item(v-slot:default='{ active, toggle }' :value="zone")
                      v-layout.py-5.px-1
                        p.my-auto {{ zone.name }}
                        v-spacer
                        v-icon.my-auto(v-if="active" color="success") mdi-check-circle

    .delivery-method-layout(v-if="page === 2")
      v-container(style="max-width:600px")
        .select-delivery-methods(v-if="selectedZone.shipping_methods.includes('pickup')")
          div.title.text-center.font-weight-bold Select delivery methods
          v-row.my-5(no-gutters)
            v-col.pa-2
              v-btn.white--text.px-0(color="accent" block :outlined="methodSelected !== 'pickup'" @click="methodSelected = 'pickup'")
                v-icon.mr-2 mdi-store
                | Self-Pickup
            v-col.pa-2
              v-btn.white--text.px-0(color="teal" block :outlined="methodSelected !== 'delivery'" @click="methodSelected = 'delivery'" :disabled="selectedZone.shipping_methods.filter(f => f !== 'pickup').length === 0")
                v-icon.mr-2 mdi-moped
                | Delivery

        .pickup-point-layout(v-if="methodSelected === 'pickup'")
          div.title.text-center.font-weight-bold.mb-4 Pickup location:
          v-card.pa-4.mb-5(outlined)
            template(v-if="selectedZone.pickup_address")
              linkify-text.body-2.text-center(:text="selectedZone.pickup_address")

        .postcode-layout(v-if="methodSelected === 'delivery' || !selectedZone.shipping_methods.includes('pickup')")
          div.title.text-center.font-weight-bold.mb-4 Write your postcode
          v-form(ref="postcodeForm")
            div.label.basic600--text {{ $t('postcode.label') }}
            v-text-field.mt-2(v-model='form.postcode' :placeholder="$t('postcode.placeholder')" background-color="basic200" height="40" outlined dense persistent-hint :rules="rules.not_empty" type="number")
          
        v-layout.py-8
          v-btn.mx-auto(text @click="goBackZones()")
            v-icon(left small) mdi-arrow-left
            |  back

    .address-layout(v-if="page === 3")
      v-container(style="max-width:600px")
        .address-layout
          div.title.text-center.font-weight-bold Fill in address
          div.text-body-2.text-center.error--text(v-if="!cityCovered") Delivery is not available for your address
          v-form(v-else ref="form")
            div.label.basic600--text.mt-4 {{ $t('address_1.label') }}
            v-text-field.mt-2(v-model="address.address_1" :placeholder="$t('address_1.placeholder')" background-color="basic200" height="40" outlined :rules="rules.not_empty")
            div.label.basic600--text {{ $t('address_2.label') }}
            v-text-field.mt-2(v-if="isEditing" v-model="address.address_2" :placeholder="$t('address_2.placeholder')" background-color="basic200" height="40" outlined)
            v-combobox.mt-2(v-else @input.native="address.address_2=$event.srcElement.value" :placeholder="$t('address_2.placeholder')" background-color="basic200" height="40" outlined :items="addresses2")
              template(v-slot:item="{ index, item }")
                v-layout(@click="address.address_2=item")
                  v-list-item-content
                    v-list-item-title(v-text="item")
            div.label.basic600--text {{ $t('postcode.label') }}
            v-text-field.mt-2(v-model="address.postcode" :placeholder="$t('postcode.placeholder')" background-color="basic200" height="40" outlined :rules="rules.not_empty" readonly)
              v-icon(color="green lighten-1" slot="append") mdi-check-circle
            div.label.basic600--text {{ $t('city.label') }}
            v-text-field.mt-2(v-model="address.city" :placeholder="$t('city.placeholder')" background-color="basic200" height="40" outlined :rules="rules.not_empty" :readonly="manualAddress? false: true")
              v-icon(v-if="!manualAddress" color="green lighten-1" slot="append") mdi-check-circle
            div.label.basic600--text {{ $t('state.label') }}
            v-text-field.mt-2(v-model="address.state" :placeholder="$t('state.placeholder')" background-color="basic200" height="40" outlined :rules="rules.not_empty" :readonly="manualAddress? false: true")
              v-icon(v-if="!manualAddress" color="green lighten-1" slot="append") mdi-check-circle
            div.label.basic600--text {{ $t('country.label') }}
            v-text-field.mt-2(v-model="address.country" :placeholder="$t('country.placeholder')" background-color="basic200" height="40" outlined :rules="rules.not_empty" :readonly="manualAddress? false: true")
              v-icon(v-if="!manualAddress" color="green lighten-1" slot="append") mdi-check-circle
        
        v-layout.py-4
          v-btn.mx-auto(text @click="page = 2")
            v-icon(left small) mdi-arrow-left
            | back

    .shipping-layout(v-if="page === 4")
      v-container(style="max-width:600px")  
        v-layout.my-6(v-if="isFetching")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
        v-form(v-else ref="addressForm")
          v-card.mb-12(v-if="couriers.length > 0")
            v-list.pa-0
              v-list-item-group(v-model='selectedCourierIndex', color='primary')
                template(v-for='(courier, index) in couriers')
                  v-divider(v-if="index != 0")
                  v-list-item(v-slot:default='{ active, toggle }' :disabled="courier.disabled")
                    // Manual shipping
                    v-layout.py-2(v-if="courier.shipping_method == 'manual'")
                      v-card.my-auto
                        v-img(:src="require('@/assets/images/delivery.jpg')" width="70" height="70")
                      div.mx-2
                        template(v-if="courier.disabled")
                          div.c1.danger500--text {{ courier.title }}
                        template(v-else)
                          div {{ courier.title }}
                          div.font-weight-bold(v-if="!courier.disabled") {{ courier.fee | displayPrice }}
                          div(v-if="courier.meta_data.cod")
                            v-chip.white--text.px-2(color="grey darken-3" x-small style="height: 17px;")
                              | COD available
                              v-icon.ml-1(x-small) mdi-check-circle

                    // Easyparcel
                    v-layout.py-2(v-if="courier.shipping_method == 'easyparcel'")
                      v-card.my-auto
                        v-img(:src="courier.disabled ? require('@/assets/images/logo_easyparcel_small.png') : require(`@/assets/images/couriers/${courier.title}.png`)"
                               width="70" height="70")
                      div.mx-2
                        template(v-if="courier.disabled")
                          div.c1.danger500--text.font-weight-bold {{ courier.title }}
                        template(v-else)
                          div {{ courier.title }}
                          div.grey--text {{ courier.meta_data.delivery }}
                          div.font-weight-bold {{ courier.fee | displayPrice }}

                    // Zepto
                    v-layout.py-2(v-if="courier.shipping_method == 'zepto'")
                      v-card.my-auto
                        v-img(:src="require('@/assets/images/icon_zepto.png')" width="70" height="70")

                      div.mx-2
                        template(v-if="courier.disabled")
                          div.c1.danger500--text.font-weight-bold {{ courier.title }}
                        template(v-else)
                          div {{ courier.title }}
                          div.grey--text {{ courier.meta_data.distance }} km
                          div.font-weight-bold(v-if="!courier.disabled") {{ courier.fee | displayPrice }}
                    
                    // Lalamove
                    v-layout.py-2(v-if="courier.shipping_method == 'lalamove'")
                      v-card.my-auto
                        v-img(:src="require('@/assets/images/icon_lalamove.png')" width="70" height="70")
                      div.mx-2
                        template(v-if="courier.disabled")
                          div.c1.danger500--text.font-weight-bold {{ courier.title }}
                        template(v-else)
                          div {{ courier.title }}
                          div.font-weight-bold(v-if="!courier.disabled") {{ courier.fee | displayPrice }}

                    v-list-item-action(v-show="active")
                      v-btn(icon)
                        v-icon(color='success') mdi-check

          template(v-else)
            v-layout.my-6
              v-row.fill-height.ma-0(align='center' justify='center')
                p.text-body-2.text-center.error--text No couriers available for your delivery address
      
          v-layout.my-8
            v-btn.mx-auto(text @click="goBackAddress()")
              v-icon(left small) mdi-arrow-left
              | back

    v-footer.white(fixed app)
      v-container.px-0.pt-1(style="max-width:580px")
        v-btn.textColorAccent.white--text(v-if="page === 1" block :loading="isLoading" :disabled="!selectedZone" @click="page++") {{ $t('next') }}
        template(v-if="page === 2")
          v-btn.textColorAccent.white--text(v-if="methodSelected === 'pickup'" block :loading="isLoading" @click="saveShippingFee('pickup')" ) {{ $t('save') }}
          v-btn.textColorAccent.white--text(v-if="methodSelected === 'delivery' || !selectedZone.shipping_methods.includes('pickup')" block :loading="isLoading" @click="fetchPostcodes()") {{ $t('next') }}
        v-btn.textColorAccent.white--text(v-if="page === 3" block :loading="isLoading" :disabled="!cityCovered" @click="saveAddress()") {{ $t('next') }}
        v-btn.textColorAccent.white--text(v-if="page === 4 && selectedCourierIndex!=null" block :loading="isLoading" :disabled="couriers.length == 0 || isFetching" @click="saveShippingFee('delivery')") {{ $t('save') }}
</template>

<script>
import { mapActions } from 'vuex'
import HeadBar from '@/components/forms/HeadBar.vue'
import LinkifyText from '@/components/LinkifyText.vue'

export default {
  name: 'DeliveryOptions',
  components: { HeadBar, LinkifyText },
  props: ['lead'],
  data: (v) => ({
    leadData: v.lead,
    page: 1,
    methodSelected: null,
    isEditing: false,
    manualAddress: false,
    address:  v.lead.shipping_address || {
      address_1: null,
      address_2: '',
      postcode: null,
      city: null,
      state: null,
      country: null
    },
    form: {
      postcode: null,
      postcodeAddresses: [],
      address: null
    },
    selectedZone: null,
    selectedMethod: null,
    zones: [],
    selectedOption: null,
    options : [],
    isFetching: false,
    couriers : [],
    selfPickup: {},
    addresses2: [],
    selectedCourierIndex: null,
    isLoading: false,
    errorMessage: '',
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      not_null: [val => val != null || 'This field is required']
    }
  }),
  watch: {
    page (val) {
      if (val === 2) {
        this.fetchPickup()
      }
    }
  },
  computed: {
    cityCovered () {
      if (this.selectedZone == null || this.selectedZone.cities == null || this.address.city == null) {
        return true
      }
      return this.selectedZone.cities.includes(this.address.city)
    }
  },
  mounted () {
    this.fetchZones()
    // this.isEditing = this.$route.query.edit
    if (this.address.postcode) {
      this.form.postcode = this.address.postcode
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    goBackAddress (){
      this.couriers = []
      this.selectedCourierIndex = null
      this.errorMessage = ''
      this.page = 2
    },
    goBackZones (){
      // Back to zone selection
      this.selectedZone = null
      this.couriers = []
      this.selectedCourierIndex = null
      this.errorMessage = ''
      this.methodSelected = null
      this.page = 1
    },
    fetchPostcodes () {
      if (!this.$refs.postcodeForm.validate()) {
        return
      }
      if (this.form.postcode === this.address.postcode) {
        this.isEditing = true
        this.page++
        return
      }
      this.isLoading = true
      this.$axios.get(`/shipping/postcodes?postcode=${this.form.postcode}`).then((response) => {
        const addresses = response.data
        this.page++
        if (addresses.length > 0 && addresses[0].postcode) {
          this.address.postcode = addresses[0].postcode
          this.address.city = addresses[0].city
          this.address.state = addresses[0].state
          this.address.country = addresses[0].country
          addresses.forEach(address => {
            this.addresses2.push(address.address_2)
          })
        } else {
          this.manualAddress = true
          this.address.postcode = this.form.postcode
        }
      })
      .catch(() => {
        this.page++
        this.manualAddress = true
        this.address.postcode = this.form.postcode
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    fetchZones () {
      this.$axios.get(`/forms/${this.leadData.form.slug}/zones`)
        .then((response) => {
          this.zones = response.data
          if (response.data.length === 1) {
            this.selectedZone = response.data[0]
            this.page = 2
          }
        })
        .catch(() => {})
    },
    fetchPickup () {
      this.$axios.get(`/shipping/fees/${this.leadData.pid}/?zone=${this.selectedZone.id}&pickup=true`)
        .then((resp) => {
          this.selfPickup = resp.data[0]
        })
        .catch(() => {})
    },
    fetchCouriers () {
      if (!this.leadData.shipping_address) return
      this.isFetching = true
      this.$axios.get(`/shipping/fees/${this.leadData.pid}/?zone=${this.selectedZone.id}&pickup=false`)
        .then((response) => {
          response.data.forEach(courier => {
            this.couriers.push(courier)
          })
          if (this.couriers.length == 1 && !this.couriers[0].disabled) {
            this.selectedCourierIndex = 0
          }
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.message) {
            this.errorMessage = e.response.data.message
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          }
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    saveAddress () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      const params = {
        shipping_address: this.address
      }
      this.axios.patch(`/leads/${this.leadData.pid}/`, params)
        .then(resp => {
          this.leadData = resp.data
          this.page++
          this.fetchCouriers()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    saveShippingFee (method) {
      let courier = {}
      if (method === 'pickup') {
        courier = this.selfPickup
      } else if (!this.couriers[this.selectedCourierIndex]) {
        this.showMessage(['error', this.$t('error_message.please_choose_courier')])
        return
      } else {
        courier = this.couriers[this.selectedCourierIndex]
      }
        
      this.isLoading = true
      let params = {
        fee: courier.fee,
        lead: this.leadData.id,
        shipping_method: courier.shipping_method,
        meta_data: courier.meta_data,
        signature: courier.signature,
        zone: this.selectedZone.id
      }

      if (this.leadData.shipping) {
        this.axios.patch(`/shipping/shippings/${this.leadData.shipping.id}/`, params)
        .then(() => {
          location.href = `/invoices/${this.leadData.pid}/`
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
      } else {
        this.axios.post(`/shipping/shippings/`, params)
        .then(() => {
          location.href = `/invoices/${this.leadData.pid}/`
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
      }
    },
    clickAskMerchat () {
      let storeUrl = process.env.VUE_APP_ENV === 'test' ? `https://${process.env.VUE_APP_SHORT_URL_DOMAIN}/${this.leadData.pid}?store` : `https://yezza.store/${this.leadData.pid}`
      let productMessage = ''
      let count = 1
      this.leadData.products.forEach(prod => {
        productMessage = productMessage.concat(`${count}. ${encodeURIComponent(prod.name)} (x${prod.quantity})%0d%0a`)
        count ++
      })
      let message = `Hi, apakah pilihan penghantaran yang sesuai untuk pembelian:%0d%0a%0d%0a${productMessage}%0d%0a${encodeURIComponent(`Order Form: ${storeUrl}`)}`
      message = message.replace(/\./g, '%2E')
      message = message.replace(/&/g, '%26')
      message = message.replace(/\?/g, '%3F')
      window.open(`https://api.whatsapp.com/send?phone=${this.leadData.member.phone}&text=${message}`, '_blank')
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "address": {
      "label": "Address",
      "placeholder": "Select Address"
    },
    "address_1": {
      "label": "Address Line 1",
      "placeholder": "e.g. K-3-01, Conezion, Persiaran IRC3"
    },
    "address_2": {
      "label": "Address Line 2",
      "placeholder": "e.g. IOI Resort City"
    },
    "postcode": {
      "label": "Postcode",
      "placeholder": "e.g. 62502"
    },
    "city": {
      "label": "City",
      "placeholder": "e.g. Putrajaya"
    },
    "state": {
      "label": "State",
      "placeholder": "e.g. Wilayah Persekutuan Putrajaya"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Malaysia"
    },
    "next": "Next",
    "save": "Save"
  },
   "id": {
    "address": {
      "label": "Alamat",
      "placeholder": "Pilih alamat"
    },
   "address_1": {
      "label": "Nama Jalan, Gedung, No Rumah, RT/RW, Kelurahan",
      "placeholder": "e.g. Jalan Prof. Joko Sutono Sh No.999, RT.14/RW.6, Petogogan, "
    },
    "address_2": {
      "label": "Kecamatan",
      "placeholder": "Kec. Kby. Baru"
    },
    "postcode": {
      "label": "Kode Pos",
      "placeholder": "12160"
    },
    "city": {
      "label": "Kota",
      "placeholder": "Kota Jakarta Selatan"
    },
    "state": {
      "label": "Provinsi",
      "placeholder": "DKI Jakarta"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Indonesia"
    },

    "next": "Teruskan",
    "save": "Simpan"
  }
}
</i18n>
